import React from "react";

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div style={overlayStyle}>
      <div style={dialogStyle}>
        <h4>Confirm Delete</h4>
        <p>{message || "Are you sure you want to delete this item?"}</p>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button style={yesStyle} onClick={onConfirm}>
            Yes
          </button>
          <button style={noStyle} onClick={onCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const dialogStyle = {
  backgroundColor: "#fff",
  padding: "30px",
  borderRadius: "10px",
  textAlign: "center",
  boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
  width: "300px",
};

const yesStyle = {
  backgroundColor: "#d9534f",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const noStyle = {
  backgroundColor: "#6c757d",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default ConfirmDialog;
